export enum ResolutionMode {
    Normal,
    Panorama,
    DoublePanorama,
    Surround,
    PanoramaFocus,
    FishEye,
    Overview,
    QuadView,
    ViewArea1,
    ViewArea2,
    ViewArea3,
    ViewArea4,
}
